import { appidJsapiSign } from '@tencent/wphk-act-base-cgi';
import { to, userEnv } from '@tencent/wphk-base-utils';
import { wxBridge } from '@tencent/wphk-base-wx';
// 初始化微信.(TODO: 其实这里最好可以透传params?: IWxInitParams)
export function setUpWeixin() {
    return wxBridge.weiXinInit({
        // TODO: 暂时先写死这两个
        openTagList: ['wx-open-launch-weapp', 'wx-open-subscribe'],
        getTicket: async () => {
            const [err, data] = await to(appidJsapiSign({
                url: location.href.split('#')[0],
                appName: 'hk_life',
            }));
            if (err || !data)
                return {};
            const { appId, nonceStr, signature, timestamp } = data;
            return {
                appId,
                nonceStr,
                signature,
                timestamp,
            };
        },
    });
}
/**
 * 设置微信分享内容
 * @param link 原链接 + 分享码 + adtag
 */
export function setWxShareInfo(info) {
    const isInMp = userEnv.isInMiniProgram();
    if (isInMp) {
        // 设置小程序分享信息
        !!info.mp && wxBridge.setMpShareInfo(info.mp);
    }
    else {
        // 设置 h5 分享信息
        !!info.wx && wxBridge.setShareInfo(info.wx);
    }
}
